<template>

      <v-card
          class="mx-auto"
          outlined
          flat
        >
          <v-list-item two-line class="ma-2">
            <v-list-item-content>
              <v-list-item-title class="title-name mb-1">
                {{ user.name }}  {{ user.surname }}
              </v-list-item-title>
              <v-list-item-subtitle>

                <span class="mr-1 chip-title">ID ASEGURADO</span>
                <span class="mr-3 chip-data">{{user.insurance_id}}</span>

                <span class="mr-1 chip-title">GÉNERO</span>
                <span class="mr-3 chip-data">{{getGenderText(user)}}</span>

                <span class="mr-1 chip-title">EDAD</span>
                <span class="mr-3 chip-data">{{user.age }}</span>

              </v-list-item-subtitle>
            </v-list-item-content>

            <v-btn class="app-button risk-button" :color="getRiskBubbleColor(user)">
              {{ getNumberOfSymptomsText(user) }}
            </v-btn>
          </v-list-item>

          <v-card-actions class="ma-0 pa-0 ml-2">

            <v-btn
              color="white"
              elevation=0
              class="mr-1 pb-2 primary--text card-button"
              @click="$router.push({
                name: 'UserProfile',
                params: { id: user.id }
              })"
            >
              <svgicon icon="fileBlue" width="1.2rem" height="1.2rem" color="#29a8e3"></svgicon>
              <span class="ml-1">VER PERFIL</span>
            </v-btn>

            <v-btn
              color="white"
              elevation=0
              class="mr-1 pb-2 grey--text card-button"
            >
              <svgicon icon="phone" width="1.2rem" height="1.2rem" color="#404a57"></svgicon>
              <span class="ml-1">{{user.phone_number ? '+' + user.phone_prefix : ''}}{{user.phone_number}}</span>
              
            </v-btn>

            <v-spacer></v-spacer>
              <v-btn
                elevation=0
                :class="user.is_intervened ? 'is-intervened-btn' : 'not-intervened-btn'"
                @click="$emit('expanded', user.id)"
              >
                <svgicon icon="tick" v-if="user.is_intervened" class="card-button-icon mr-2" width="1rem" height="1rem" color="#29a8e3"></svgicon>
                <span class="contact-text"
                  v-html="user.is_intervened ? 'RESPONDIDO' : 'Pendiente de respuesta'"
                  >
                </span>
                <svgicon 
                  :icon="isExpanded ? 'less' : 'more'" 
                  width="2rem" 
                  height="2rem" 
                  class="ml-2"
                  color="#0d658e">
                </svgicon>
            </v-btn>

          </v-card-actions>

          <v-expand-transition >
            <div v-show="isExpanded">
              <my-user-card-expansion 
                :user="user"
                @cancelComment="$emit('expanded', null)"
              />
            </div>
          </v-expand-transition>

        </v-card>

</template>

<script>

  import MyUserCardExpansion from './MyUserCardExpansion'

  export default {
    name: 'Filters',

    components: {
        MyUserCardExpansion
    },

    props: {
      user: {
        type: Object,
        required: true
      },
      isExpanded: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      showExpansion: false
    }),
  }
</script>

<style lang="scss" scoped>
  .card-button {
    font-weight: 600;
    font-family: "Source Sans Pro Semibold";

    .card-button-icon {
      margin-right: 2px !important;
      font-size: 1.125rem;
    }
  }

  .chip-title {
    color: #8c95a1;
    font-size: 1.125rem;
  }

  .chip-data {
    font-weight: 600;
    color: #555f6b;
    font-size: 1rem;
  }

  .title-name {
    color: #222c38;
    font-weight: 600;
    font-size: 1.375rem;
    font-family: "Source Sans Pro Semibold";
  }

  .risk-button {
    width: 154px !important;
    height: auto !important;
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
    pointer-events: none;
  }


  .is-intervened-btn {
     background-color: #c3ecff !important;
     color: #29a8e3;
     font-weight: bold;
     font-size: 1.125rem;
     letter-spacing: 0;
  }

  .not-intervened-btn {
     background-color: #f5f8fc !important;
     color: #aab2bd;
     font-weight: bold;
     font-size: 1.125rem;
     letter-spacing: 0;
  }

  .contact-icon {
    color: #0d658e !important;
    border: 1px solid #0d658e;
    border-radius:50%;
    margin-left: 5px;
  }

  .contact-text {
    font-size:0.925rem;
  }
</style>